(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artist-contact"] && !Shopify.designMode) return;
  try {
    
  const episodeDialog = document.querySelector('.tw-episode-dialog');
  if (episodeDialog) {
    const playerContainer = episodeDialog.querySelector('.tw-episode-dialog__player');
    let episodeTrigger;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-painting-episode]');
      if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey) return;
      const videoId = new URL(trigger.dataset.paintingEpisode).searchParams.get('v');
      if (!videoId || !/^[a-zA-Z0-9_-]{11}$/.test(videoId)) return;
      event.preventDefault();
      episodeTrigger = trigger;
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&fs=1';
      frame.title = episodeDialog.querySelector('strong').textContent;
      frame.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      playerContainer.replaceChildren(frame);
      episodeDialog.showModal();
      document.documentElement.classList.add('tw-episode-is-open');
    });
    episodeDialog.querySelector('[data-close-episode]').addEventListener('click', () => episodeDialog.close());
    episodeDialog.addEventListener('click', (event) => {
      const bounds = episodeDialog.getBoundingClientRect();
      if (event.target === episodeDialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) episodeDialog.close();
    });
    episodeDialog.addEventListener('close', () => {
      playerContainer.replaceChildren();
      document.documentElement.classList.remove('tw-episode-is-open');
      episodeTrigger?.focus({preventScroll: true});
    });
  }
  if (window.location.pathname.includes('/pages/contact')) {
    const paintingTitle = new URLSearchParams(window.location.search).get('painting');
    const messageField = document.querySelector('[name="contact[body]"]');
    if (paintingTitle && messageField && !messageField.value) messageField.value = 'I’d like to ask about ' + paintingTitle + '.\n\n';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curated-original-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tw-gallery').forEach((gallery) => {
    const buttons = gallery.querySelectorAll('[data-price-filter]');
    const cards = gallery.querySelectorAll('.tw-painting');
    buttons.forEach((button) => button.addEventListener('click', () => {
      const filter = button.dataset.priceFilter;
      let availableCount = 0;
      buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      cards.forEach((card) => {
        const price = Number(card.dataset.price);
        const available = card.dataset.available === 'true';
        const matches = filter === 'all' || available && (
          filter === 'under_500' && price < 50000 ||
          filter === 'under_1000' && price >= 50000 && price < 100000 ||
          filter === 'under_2000' && price >= 100000 && price < 200000 ||
          filter === 'over_2000' && price >= 200000
        );
        card.hidden = !matches;
        if (matches && available) availableCount++;
      });
      gallery.querySelectorAll('.tw-gallery__detail, .tw-gallery__invitation').forEach((item) => item.hidden = filter !== 'all');
      const sold = gallery.querySelector('#sold');
      if (sold) sold.hidden = filter !== 'all';
      const empty = gallery.querySelector('.tw-gallery__empty');
      if (empty) empty.hidden = availableCount > 0;
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["painting-progress-gallery"] && !Shopify.designMode) return;
  try {
    
  function initializePaintingProgress() {
    document.querySelectorAll('[data-painting-progress]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const viewer = section.querySelector('dialog');
      const image = viewer.querySelector('img');
      let trigger;
      section.querySelectorAll('[data-progress-image]').forEach(button => {
        button.addEventListener('click', () => {
          trigger = button;
          image.src = button.dataset.progressImage;
          image.alt = button.querySelector('img').alt;
          viewer.showModal();
        });
      });
      viewer.querySelector('button').addEventListener('click', () => viewer.close());
      viewer.addEventListener('click', event => {
        if (event.target !== viewer) return;
        const bounds = viewer.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) viewer.close();
      });
      viewer.addEventListener('close', () => { image.removeAttribute('src'); trigger?.focus(); });
    });
  }
  initializePaintingProgress();
  document.addEventListener('shopify:section:load', initializePaintingProgress);

  } catch(e) { console.error(e); }
})();
})();
